import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';

import { NguiScrollableModule } from '@ngui/scrollable';
import { scrollTo } from '@ngui/utils';
import { BudgetService } from '../../service/budget.service';
import { CashFlowService } from '../../service/cashflow.service';
import { CompanyService } from '../../service/company.service';
import { LoanService } from '../../service/loan.service';
import { OperatingexpensesService } from '../../service/operatingexpenses.service';
import { ProjectService } from '../../service/project.service';

@Component({
  selector: 'app-cash-flow-records',
  templateUrl: './cash-flow-records.component.html',
  styleUrls: ['./cash-flow-records.component.css', '../cashflow.component.css'],
})
export default class CashFlowRecordsComponent implements OnInit {
  constructor(
    public cashflowservice: CashFlowService,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    private operatingexpensesService: OperatingexpensesService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    private budgetService: BudgetService,
    private loanService: LoanService
  ) {
    this.cashflowservice.getProjectData();
  }

  // DECLARATION FOR FIXED TABLE SCROLLING
  id = 's1';

  hid = 'h1';

  wid = 'w1';

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() print: boolean;

  @Input() showSummary: boolean;

  companyId = '';

  year: Number = 1;

  labels: string[] = [];

  months: number[] = [];

  // DECLARATION OF OBJECT TO pass data to table component to SHOW TEN YEARS DATA IN PRINTING AS WELL AS IN SCREN
  parentObject: any = {
    labels: new Array(),
    months: new Array(),
    tds: new Array(),
    tables: new Array(1),
    minimumValue: 0,
  };

  scrollTo(selector, parentSelector, horizontal) {
    scrollTo(
      selector, // scroll to this
      parentSelector, // scroll within (null if window scrolling)
      horizontal, // is it horizontal scrolling
      0 // distance from top or left
    );
    this.hid = selector.split('#').join('');
  }

  ngOnInit() {
    const self = this;
    // set parent object to pass table component
    const callback = (data) => {
      for (let i = 1; i <= 120; i++) {
        self.parentObject.months.push(i);
      }
      self.parentObject.labels.push(
        'Gross Operating Income',
        'Less: Operating Expenses',
        'Net Operating Income',
        'Less: Debt Service',
        'Net Cash Flow',
        'Account 1: Operating Capital',
        'Account 2: Maintenance Reserve',
        'Loan Proceeds',
        'Loan Payoffs'
      );
      self.parentObject.minimumValue = Math.min.apply(Math, data.operatingArray);
      self.parentObject.tds.push(
        data.grossOperatingIncomeArray,
        data.totalOpexArray,
        data.netOperatingExpensesArray,
        data.debtServiceArray,
        data.profitLossArray,
        data.operatingArray,
        data.maintenanceArray,
        data.cashInfusionArray,
        data.cashDistributionArray
      );
      if (this.print) {
        // self.parentObject.tables.push(Array.from(new Array(3),(val,index)=>index));
        self.parentObject.tables = new Array(4);
      }
      self.parentObject.print = this.print;
      self.parentObject.start_up_month = data.start_up_month;
    };
    this.cashflowservice.getCashFlow(callback);
  }
}



// WEBPACK FOOTER //
// ./src/app/cashflow/cash-flow-records/cash-flow-records.component.ts